export function matchFullTextCaseInsensitive(
  text: string,
  searchValue: string
) {
  const sanitizedSearchValue = searchValue.replace(
    /[.*+?^${}()|[\]\\]/g,
    "\\$&"
  ); // Escape special characters
  return String(text).match(new RegExp(sanitizedSearchValue, "i"));
}

export function capitalizeWord(word: string) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}
